import css from 'styled-jsx/css';

const styles = css.global`.title {
  font-size: 24px;
  font-family: 'SantanderHeadline';
  line-height: 36px;

  color: #222222;
  width: 70%;
  letter-spacing: 0;
  margin: 30px 0px;
}
.text {
  font-size: 18px;
  font-family: 'SantanderText';
  line-height: 26px;
  width: 80%;
  color: #444444;
  margin-bottom: 30px;
}
.icons-box {
  display: flex;
}
.icon {
  margin-right: 15px;
  height: 39px;
}
.icon-p {
  /* margin-block-start: auto; */
  font-family: 'SantanderText';
  font-size: 18px;
  line-height: 20px;
}
.great-box {
  display: flex;
  background-color: #f5f9fb;
  width: 89%;
  height: 250px;
  margin-top: 50px;
  padding: 30px;
  box-sizing: border-box;
}
.great-title {
  color: #cc0000;
  font-size: 24px;
  font-family: 'Open Sans';
  font-weight: 600;
  width: 75%;
  margin-block-start: auto;
}

.great-text {
  color: #444444;
  font-size: 18px;
  line-height: 32px;
  font-family: 'SantanderText';
  width: 71%;
  margin-block-start: auto;
}
.great-geraltext {
  margin-left: 35px;
}
@media (max-width: 991px) {
  .title {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    width: 100%;
    margin: 15px 0;
  }
  .text {
    font-size: 18px;
    line-height: 24px;
    color: #222222;
    width: 100%;
  }
  .financiamento {
    color: #222222;
    font-weight: normal;
  }
  .icon-p {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  }
  .great-box {
    width: 100%;
    height: 550px;
    flex-direction: column;
    margin: auto;
    padding: 10px 0 25px 0;
  }
  .great-img {
    margin: auto;
  }
  .great-geraltext {
    margin: auto;
  }
  .great-title {
    font-family: 'SantanderHeadline';
    font-weight: normal;
    color: #cc0000;
    width: 256px;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 5px;
  }
  .great-text {
    width: 256px;
    font-family: 'SantanderText';
    font-size: 18px;
    line-height: 24px;
    color: #222222;
  }
}
`;

export default styles;